<template>
  <el-popover ref="popover" placement="right" width="600" trigger="click">
    <el-collapse accordion>
      <el-collapse-item
        v-for="item in (tableList[Index] && tableList[Index].MaintenanceObject) || []"
        :title="item.application_type"
        :key="item.application_type"
        :name="item.application_type"
      >
        <el-table ref="table" :data="item.device_Pagination_list" style="width: 100%">
          <el-table-column
            prop="DeviceNumber"
            label="设备编号"
            min-width="5%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DeviceName"
            label="设备名称"
            min-width="5%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DeviceBrand"
            label="品牌"
            min-width="5%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="RoomName"
            label="房间号"
            min-width="5%"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DeviceModel"
            label="型号"
            min-width="5%"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          small
          layout="prev, pager, next"
          :total="(item.device_info_sub && item.device_info_sub.length) || 0"
          @next-click="nextPage(item, $event)"
          @prev-click="prevPage(item, $event)"
          @current-change="currentChange(item, $event)"
        >
        </el-pagination>
      </el-collapse-item>
    </el-collapse>
    <el-button slot="reference" type="primary" @click="handleClick">查看维护对象</el-button>
  </el-popover>
</template>
<script>
export default {
  name: 'maintenanceObjCheck',
  props: ['TableList', 'Index'],
  data() {
    return {
      tableList: [],
      isDataLoaded: false,
    };
  },
  methods: {
    handleClick() {
      if (!this.isDataLoaded && this.TableList && this.TableList[this.Index] && this.TableList[this.Index].MaintenanceObject) {
        const processedData = JSON.parse(JSON.stringify(this.TableList));
        for (let i = 0; i < processedData[this.Index].MaintenanceObject.length; i++) {
          const item = processedData[this.Index].MaintenanceObject[i];
          if (item.device_info_sub && item.device_info_sub.length > 0) {
            processedData[this.Index].MaintenanceObject[i].device_Pagination_list =
              item.device_info_sub.slice(0, Math.min(10, item.device_info_sub.length));
          } else {
            processedData[this.Index].MaintenanceObject[i].device_Pagination_list = [];
          }
        }
        this.tableList = processedData;
        this.isDataLoaded = true;
      }
    },
    nextPage(item, index) {
      if (item && item.device_info_sub && item.device_info_sub.length > 0) {
        const startIndex = 10 * (index - 1);
        const endIndex = Math.min(startIndex + 10, item.device_info_sub.length);
        item.device_Pagination_list = item.device_info_sub.slice(startIndex, endIndex);
      }
    },
    prevPage(item, index) {
      if (item && item.device_info_sub && item.device_info_sub.length > 0) {
        const startIndex = Math.max(0, 10 * (index - 1) - 10);
        const endIndex = 10 * (index - 1);
        item.device_Pagination_list = item.device_info_sub.slice(startIndex, endIndex);
      }
    },
    currentChange(item, index) {
      if (item && item.device_info_sub && item.device_info_sub.length > 0) {
        const startIndex = 10 * (index - 1);
        const endIndex = Math.min(startIndex + 10, item.device_info_sub.length);
        item.device_Pagination_list = item.device_info_sub.slice(startIndex, endIndex);
      }
    }
  },
};
</script>
